<template>
  <div>
    <div class="ny-body ny-zsy">
      <div class="left">
        <img src="/img/login-pic.png" alt="">
      </div>
      <div class="right">
        <div class="form-box">
          <h3>{{ $t('login.title') }}</h3>
          <div class="bind">
            <a href="javascript:void(0);" @click="handleRegister" class="blue">{{ $t('login.register') }}</a>
          </div>
          <el-form ref="loginForm" :model="loginInfo">
            <el-form-item prop="username">
              <div class="input-box input-box1 onfocusstyle user-word">
                <label for="loginname" class="icon-user"></label>
                <el-input v-model="loginInfo.username" id="loginname" :placeholder="$t('login.usernamePlaceholder')"
                  class="position-input" maxlength="20" autocomplete="off"></el-input>
                <div class="Validform_checktip formtip">
                  <span class=""><i></i><label></label></span>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="passwd">
              <div class="input-box onfocusstyle passw-word">
                <label for="passw" class="icon-passw"></label>
                <el-input v-model="loginInfo.passwd" type="password" id="passw"
                  :placeholder="$t('login.passwordPlaceholder')" class="position-input" maxlength="20"
                  autocomplete="off"></el-input>
                <div class="Validform_checktip formtip">
                  <span class=""><i></i><label></label></span>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="validateCode">
              <div class="input-box onfocusstyle yanm-div">
                <label for="authcode" class="icon-passw"></label>
                <el-input v-model="loginInfo.validateCode" maxlength="4" id="authcode"
                  :placeholder="$t('login.codePlaceholder')" class="position-input"
                  @keyup.enter.native="handleLogin"></el-input>
                <img width="150" height="50" :src="loginInfo.codeImage" id="mx" style="cursor:pointer;"
                  :alt="$t('login.codeAlt')" border="1" :title="$t('login.codeAlt')" @click="generateCode">
                <div class="Validform_checktip formtip">
                  <span class=""><i></i><label></label></span>
                </div>
              </div>
            </el-form-item>

            <el-form-item>
              <div class="input-box sub-box">
                <el-button type="primary" @click="handleLogin">{{ $t('login.loginBtn') }}</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, generateValidateCode } from '@/api/plateform/loginApi'

export default {
  name: 'Login',
  data() {
    return {
      loginInfo: {
        username: '',
        passwd: '',
        validateCode: '',
        codeImage: ''
      }
    }
  },
  created() {
    this.generateCode()
  },
  methods: {
    generateCode() {
      generateValidateCode({ _uId: '123' })
        .then(response => {
          this.loginInfo.codeImage = response
        })
        .catch(error => {
          console.error('获取验证码失败:', error)
        })
    },
    handleLogin() {
      if (!this.loginInfo.username) {
        this.$message.error(this.$t('login.usernameRequired'))
        return
      }
      if (!this.loginInfo.passwd) {
        this.$message.error(this.$t('login.passwordRequired'))
        return
      }
      if (!this.loginInfo.validateCode) {
        this.$message.error(this.$t('login.codeRequired'))
        return
      }

      login(this.loginInfo)
        .then(response => {
          if (response.code !== 0) {
            this.$message.error(response.msg)
            return
          }
          if (response.levelCd === '03') {
            this.$store.dispatch('user/saveUserInfo', response)
            this.$router.push('/page')
          } else {
            this.$message.error(this.$t('login.notPurchaser'))
          }
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    handleRegister() {
      this.$router.push('/pageLR#/pages/plateform/register')
    }
  }
}
</script>

<style scoped>
.ny-body {
  display: flex;
  height: 100vh;
}

.left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-box {
  width: 400px;
}

.input-box {
  position: relative;
  margin-bottom: 20px;
}

.position-input {
  width: 100%;
}

.sub-box {
  margin-top: 30px;
}
</style>